import {
  AI_ASSISTANT_THREAD_PATH_PREFIX,
  buildAssistantThreadPath as buildSharedAssistantThreadPath,
  isProjectSnapshotPath,
  PROJECT_LEVEL_ROUTE_PATHS,
  PROJECT_SEARCH_PARAM_KEY,
} from "@repo/shared";

export {
  ALLOWED_PROJECT_SEARCH_PARAMS,
  PROJECT_TAB_SEARCH_PARAM_KEYS,
} from "@/lib/project-search-param-keys";

type ProjectTabSearchParams = Record<string, unknown>;

export function buildAssistantThreadPath(threadId: string): string {
  return buildSharedAssistantThreadPath(threadId);
}

export const TRANSIENT_PROJECT_SEARCH_PARAM_CLEARS: ProjectTabSearchParams = {
  q: undefined,
  rc: undefined,
  rt: undefined,
  vs: undefined,
  crf: undefined,
  crv: undefined,
  crs: undefined,
  [PROJECT_SEARCH_PARAM_KEY.sectionFocusTabKey]: undefined,
  [PROJECT_SEARCH_PARAM_KEY.sectionFocusFieldId]: undefined,
  [PROJECT_SEARCH_PARAM_KEY.sectionFocusNonce]: undefined,
  [PROJECT_SEARCH_PARAM_KEY.qualityGuardPanelFocus]: undefined,
  [PROJECT_SEARCH_PARAM_KEY.qualityGuardPanelFindingId]: undefined,
  crc: undefined,
  crcf: undefined,
};

export const ENTITY_QUALITY_GUARD_FOCUS_SEARCH_PARAM_CLEARS: ProjectTabSearchParams = {
  [PROJECT_SEARCH_PARAM_KEY.qualityGuardPanelFocus]: undefined,
  [PROJECT_SEARCH_PARAM_KEY.qualityGuardPanelFindingId]: undefined,
};
const AI_ASSISTANT_PATH_PREFIX = "/ai-assistant";
const PROJECT_LEVEL_TRANSIENT_RESET_PATHS = [
  PROJECT_LEVEL_ROUTE_PATHS.projectDocuments,
  PROJECT_LEVEL_ROUTE_PATHS.knowledge,
  PROJECT_LEVEL_ROUTE_PATHS.specificationClarificationRequests,
  PROJECT_LEVEL_ROUTE_PATHS.specificationVersionSnapshots,
  PROJECT_LEVEL_ROUTE_PATHS.specificationQualityGuard,
] as const;

const PROJECT_LEVEL_ENTITY_EXCLUSION_PATHS = [
  PROJECT_LEVEL_ROUTE_PATHS.aiAssistant,
  PROJECT_LEVEL_ROUTE_PATHS.projectDocuments,
  PROJECT_LEVEL_ROUTE_PATHS.knowledge,
  PROJECT_LEVEL_ROUTE_PATHS.specificationClarificationRequests,
  PROJECT_LEVEL_ROUTE_PATHS.specificationVersionSnapshots,
  PROJECT_LEVEL_ROUTE_PATHS.specificationQualityGuard,
  PROJECT_LEVEL_ROUTE_PATHS.projectQualityGuardConfiguration,
] as const;

export function isEntityNavigationPath(path: unknown): path is string {
  return (
    typeof path === "string" &&
    path.length > 0 &&
    path !== "/" &&
    !PROJECT_LEVEL_ENTITY_EXCLUSION_PATHS.some((rootPath) => isPathAtOrBelow(path, rootPath))
  );
}

export function isRememberedAssistantPath(path: unknown): path is string {
  return (
    typeof path === "string" &&
    (path === PROJECT_LEVEL_ROUTE_PATHS.aiAssistantHistory ||
      path === PROJECT_LEVEL_ROUTE_PATHS.aiAssistantNewChat ||
      path.startsWith(AI_ASSISTANT_THREAD_PATH_PREFIX))
  );
}

function isPathAtOrBelow(path: string, rootPath: string): boolean {
  return path === rootPath || path.startsWith(`${rootPath}/`);
}

export function shouldClearTransientProjectSearchParams(path: string): boolean {
  if (isPathAtOrBelow(path, AI_ASSISTANT_PATH_PREFIX)) {
    return true;
  }

  return PROJECT_LEVEL_TRANSIENT_RESET_PATHS.some((rootPath) => {
    if (rootPath === PROJECT_LEVEL_ROUTE_PATHS.specificationVersionSnapshots) {
      return isProjectSnapshotPath(path);
    }
    return isPathAtOrBelow(path, rootPath);
  });
}
